import Swiper from './swiper.min.js';

export default class {
  static mainSlider() {
    let heroSlider = new Swiper('.main-slider', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  }

  static bannerCarousel() {
    let bannerSlider = new Swiper('.plan-carousel__wrap', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 30,
      speed: 700,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        480: {
          slidesPerView: 1
        }
      }
    });
  }
};